import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const links = [{
  name: 'Nosotros',
  href: '#nosotros'
}, {
  name: 'Actividades',
  href: '#actividades'
}, {
  name: 'Salud',
  href: '#salud'
}, {
  name: 'Equipo',
  href: '#equipo'
}, {
  name: 'Sede',
  href: '#sede'
}, {
  name: 'Contacto',
  href: '#contacto'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-kiron-black/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-165">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-166">
        <a href="#" className="flex items-center" data-id="element-167">
          <img src="https://cdn.magicpatterns.com/uploads/gmjbqi7Rif9BiiKcd8ezw3/logo_fondo_negro.jpg" alt="Kiron Performance" className="h-10 md:h-12 object-contain" data-id="element-168" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-169">
          {links.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-kiron-teal transition-colors uppercase tracking-wider" data-id="element-170">
              {link.name}
            </a>)}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white hover:text-kiron-teal transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-171">
          {mobileMenuOpen ? <X size={28} data-id="element-172" /> : <Menu size={28} data-id="element-173" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-174">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 w-full bg-kiron-black border-t border-gray-800 shadow-2xl md:hidden" data-id="element-175">
            <div className="flex flex-col py-4 px-6 space-y-4" data-id="element-176">
              {links.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-gray-300 hover:text-kiron-teal transition-colors uppercase tracking-wider py-2 border-b border-gray-800/50" data-id="element-177">
                  {link.name}
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}